import axiosInstance from "../../utils/axios";

const project = {
  state: {
    project: [],
  },
  mutations: {
    setProject(state, project) {
      state.project = project;
    },
  },
  actions: {
    async fetchProject({ commit }, id) {
      try {
        const response = await axiosInstance.get(`/projects/${id}`);
        commit("setProject", response.data["project"]);
      } catch (error) {
        console.log("Error en el Fecth de datos");
      }
    },
    async updateProject({ commit }, putProject) {
      try {
        const response = await axiosInstance.put(
          `/projects/${putProject.id}`,
          putProject.data
        );
        commit("setProject", response.data["project"]);
      } catch (error) {
        console.log("Error al actualizar los datos");
      }
    },
    async updatePriorityProject({ commit }, putProject) {
      try {
        const response = await axiosInstance.put(
          `/projects/${putProject.id}/update_priority`,
          putProject.data
        );
        commit("setProject", response.data["project"]);
      } catch (error) {
        console.log(error);
      }
    },
    async fetchEmployeePositions() {
      try {
        const response = await axiosInstance.get("/employee_positions");
        return response.data.employee_position
      } catch (error) {
        console.log(error);
      }
    },
    async saveEstimatedWorkHours(_, payload) {
      try {
        const response = await axiosInstance.post("/estimated_work_hours", payload);
        return response.data
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {
    projectCount(state) {
      return state.project.length;
    },
  },
};

export default project;
